export const FILE_VALIDATION = {
  video: {
    acceptedMimeTypes: ['video/mp4', 'image/gif'],
    acceptedExtensions: ['.mp4', '.gif'],
    maxSizeBytes: 60 * 1024 * 1024,
    fileTypeLabel: 'MP4 or GIF',
  },
  audio: {
    acceptedMimeTypes: ['audio/mpeg', 'audio/wav', 'audio/x-wav'],
    acceptedExtensions: ['.mp3', '.wav'],
    maxDurationSeconds: 40,
    fileTypeLabel: 'MP3 or WAV',
  },
  image: {
    acceptedMimeTypes: ['image/png', 'image/jpeg', 'image/jpg'],
    acceptedExtensions: ['.png', '.jpeg', '.jpg'],
    maxSizeBytes: 5 * 1024 * 1024, // 5MB limit
    fileTypeLabel: 'PNG, JPEG, or JPG',
  },
} as const;
